<template>
    <div name="agreement" class="agreement">
        <div class="contents">
            <img class="close" src="../../assets/showcase/xi/close.png" @click="goHome"/>
            <span class="title">{{ title }}</span>
            <div class="description" v-html="html"></div>
           
            <div class="footer-button">
                <div class="button" @click="goHome">     
                    동의합니다
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'agreement',
    props: ['title', 'html'],
    methods: {
        goHome: function()
        {
            this.$emit('close')
        }
    }
}
</script>

<style scoped>
    .agreement {
        width: 100%;
        height: 100dvh;
        background: rgba(19, 20, 21, 0.50);
        position: fixed;
        padding: 0 8vw;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .contents {
        width: 100%;
        height: 62vh;
        background: #fff;
        position: relative;
        padding: 2vh 5vw;
        box-sizing: border-box;
    }
    .title {
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 4.4vw;
        font-style: normal;
        font-weight: 700;
        line-height: 181.25%;
        letter-spacing: -1.92px;
    }
    .close {
        position: absolute;
        right: 5vw;
        top: 5vw;
        width: 3.8vw;
        cursor: pointer;
    }
    .description {
        overflow: hidden;
        overflow-y: auto;
        height: 40vh;
        padding: 2.8vh 5vw;
        box-sizing: border-box;
        width: 100%;
        font-size: 1.9vw;
        color: var(--xi-dark-gray, #131415);
        font-family: Pretendard;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 2vh;
    }
    .button {
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        width: 27vw;
        aspect-ratio: 2.5/1;
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 3vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .footer-button {
        width: 100%;
        height: 10.6vh;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1vh;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/AgreementModal.vue